import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';

type useUniversalLoginDisabledReturnType = {
  disabled: boolean;
};

export function useUniversalLoginDisabled(): useUniversalLoginDisabledReturnType {
  const { isEditPage, corpData } = useCorporateFormContext();
  const disabled = isEditPage && corpData?.universalAccountsEnabled;

  return { disabled };
}
